// 时间 format
// 将秒转换为 00:00:00 格式
export function transTimeFilter(second) {
  second = Math.floor(second)
  const addZero = value => {
    return value < 10 ? `0${value}` : value
  }

  if (second < 60) {
    const s = Math.ceil(second % 60)
    // 只含有秒
    return `00:00:${addZero(s)}`
  } else if (second < 3600) {
    // 含有分秒
    const m = Math.floor(second / 60)
    const s = Math.ceil(second % 60)
    return `00:${addZero(m)}:${addZero(s)}`
  } else {
    const h = Math.floor(second / 3600)
    const m = Math.floor((second - 3600) / 60)
    const s = Math.ceil((second - 3600) % 60)
    return `${addZero(h)}:${addZero(m)}:${addZero(s)}`
  }
}

export function slice(data, begin = 0, end = 0, pured = false) {
  if (data && !pured) {
    return (data.length <= end - begin ? data : `${data.slice(begin, end)}...`).replace(/\\r\\n|<br>/g, "")
  } else if (data && pured) {
    return data.slice(begin, end)
  } else {
    return ""
  }
}
